// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1xfLx","upload":"Small_upload___oJLX","imageWrap":"Small_imageWrap__3yxf-","removeBtn":"Small_removeBtn__1m68O"};